// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-screen {
  width: 100vw;
  height: 100vh;
  background: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.tv-screen img,
.tv-screen video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


.splash {
  width: 100vw;
  height: 100vh;
  background-color: #020617;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5vw; /* TV overscan safety */
}

.lottie {
  width: clamp(240px, 35vmin, 520px);
  height: clamp(240px, 35vmin, 520px);
}`, "",{"version":3,"sources":["webpack://./src/styles/tv.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC","sourcesContent":[".tv-screen {\n  width: 100vw;\n  height: 100vh;\n  background: black;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.tv-screen img,\n.tv-screen video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n\n.splash {\n  width: 100vw;\n  height: 100vh;\n  background-color: #020617;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5vw; /* TV overscan safety */\n}\n\n.lottie {\n  width: clamp(240px, 35vmin, 520px);\n  height: clamp(240px, 35vmin, 520px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
